import { render, staticRenderFns } from "./ErrorGlobal.vue?vue&type=template&id=c3325c84&scoped=true&"
import script from "./ErrorGlobal.vue?vue&type=script&lang=js&"
export * from "./ErrorGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorGlobal.vue?vue&type=style&index=0&id=c3325c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3325c84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VIcon,VOverlay})
